import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

export default function NodeDetailModal({ open, onClose, node }) {
  const userType = localStorage.getItem("userType");
  const navigate = useNavigate();

  console.log("====================================");
  console.log(node);
  console.log("====================================");

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          borderBottom: "1px solid #eee",
          p: "18px 15px",
          lineHeight: "1",
          fontSize: "16px",
          fontWeight: "600",
        }}
      >
        Employee Details
      </DialogTitle>
      <DialogContent sx={{ p: "25px 15px !important" }}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <Box
            sx={{
              display: "grid",
              gap: "10px",
              textAlign: "center",
              m: "0 0 20px",
            }}
          >
            {node?.attributes?.imageUrl && (
              <img
                src={node.attributes.imageUrl}
                alt={node.name}
                style={{ width: 100, height: 100, borderRadius: "50%" }}
              />
            )}
            <Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px", // Adds space between text and icon
                }}
              >
                <Typography
                  variant="span"
                  sx={{
                    fontSize: "17px",
                    fontWeight: "600",
                  }}
                >
                  {node?.name}
                </Typography>
                <LinkedInIcon
                  onClick={() => {
                    window.open(node?.attributes?.linked_url);
                  }}
                />
              </Box>
              <Typography
                variant="body1"
                style={{
                  fontSize: "15px",
                  textAlign: "center",
                  fontWeight: "500",
                }}
              >
                {node?.attributes?.title || "N/A"}
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: "20px" }}>
            {/* <Typography
              variant="body1"
              sx={{
                border: "1px solid #eee",
                display: "flex",
                alignItems: "center",
                gap: "5px",
                p: "6px 20px",
                lineHeight: "1",
                fontSize: "14px",
                borderRadius: "100px",
                m: "0",
              }}
            >
              {node?.attributes?.title || "N/A"}
            </Typography> */}
            <Typography
              variant="body1"
              sx={{
                border: "1px solid #eee",
                display: "flex",
                alignItems: "center",
                gap: "5px",
                p: "6px 20px",
                lineHeight: "1",
                fontSize: "14px",
                borderRadius: "100px",
                m: "0",
              }}
            >
              <EmailIcon sx={{ m: 0, p: 0, fontSize: "14px" }} />
              {node?.attributes?.email || "N/A"}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                border: "1px solid #eee",
                display: "flex",
                alignItems: "center",
                gap: "5px",
                p: "6px 20px",
                lineHeight: "1",
                fontSize: "14px",
                borderRadius: "100px",
                m: "0",
              }}
            >
              <PhoneIcon sx={{ m: 0, p: 0, fontSize: "14px" }} />
              {node?.attributes?.phone || "N/A"}
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          borderTop: "1px solid #eee",
          p: "6px 15px",
          lineHeight: "1",
          fontSize: "16px",
          fontWeight: "600",
        }}
      >
        <Button onClick={onClose} color="primary">
          Close
        </Button>
        {userType === "ADMIN" && (
          <Button
            onClick={() => navigate(`/employee/edit/${node?.attributes?.id}`)}
            color="primary"
          >
            Edit Detail
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
